import logo from './logo.svg';
import './App.css';
import Nav from './Components/Nav/nav'
import About from './Components/About/about'

function App() {
  return (
    <>
      <Nav/>
      <About/>
    </>
  );
}

export default App;
